<template>
	<section class="m-paid-test">
		<h2 class="m-paid-test__title">{{ title }}</h2>
		<ul class="m-paid-test__list">
			<li
				v-for="item in paidTestList"
				:key="item.id"
				class="m-paid-test__item"
				@click="toGoLink(getItemUrl(item), schannel)"
			>
				<van-image
					class="m-paid-test__cover"
					:src="item.cover || item.cover_cc || item.pc_cover"
					:alt="getItemTitle(item)"
				/>

				<div class="m-paid-test__content">
					<h3 class="m-paid-test__name">{{ getItemTitle(item) }}</h3>
					<p class="m-paid-test__desc">{{ formatDesc(item) }}</p>
					<div class="m-paid-test__footer">
						<div class="m-paid-test__price">
							<img :src="priceIcon" alt="" />
							<span>{{ formatPrice(item) }}</span>
						</div>
						<button
							class="m-paid-test__button"
							type="button"
							@click.stop="toGoLink(getItemUrl(item), schannel)"
						>
							{{ item.button_text || "立即測試" }}
						</button>
					</div>
				</div>
			</li>
		</ul>
	</section>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import api from "~/api/api";
import { goLink } from "~/utils/common";
import priceIcon from "../../../pc/images/logo_icon.png";

const DEFAULT_PRICE = "495";
const DEFAULT_DESC = "你的睡眠透露出你怎樣的心理訴求?";

const props = defineProps({
	data: {
		type: Object,
		default: () => [],
	},
	title: {
		type: String,
		default: "付費測試",
	},
	schannel: {
		type: String,
		default: "",
	},
});

const apiPaidTestList = ref([]);

const fallbackPaidTestList = computed(() =>
	(Array.isArray(props.data) ? props.data : []).filter(Boolean).slice(0, 6)
);

const paidTestList = computed(() =>
	apiPaidTestList.value.length ? apiPaidTestList.value : fallbackPaidTestList.value
);

function resolvePaidTestList(res) {
	const data = res?.data;
	if (Array.isArray(data)) return data;
	if (Array.isArray(data?.list)) return data.list;
	if (Array.isArray(data?.data)) return data.data;
	if (Array.isArray(data?.data?.list)) return data.data.list;
	return [];
}

async function fetchPaidTestList() {
	try {
		const res = await api.getForecastZone({
			v: 2,
			page: 1,
			size: 6,
			is_test: 1,
		});
		apiPaidTestList.value = resolvePaidTestList(res).slice(0, 6);
	} catch (error) {
		console.error("获取付费测试列表失败:", error);
	}
}

onMounted(() => {
	fetchPaidTestList();
});

function formatPrice(item) {
	const rawPrice =
		item?.price || item?.final_price || item?.discount_price || item?.unit_price || item?.min_price;

	if (rawPrice === undefined || rawPrice === null || rawPrice === "") {
		return DEFAULT_PRICE;
	}

	return String(rawPrice).replace(/[^\d.]/g, "") || DEFAULT_PRICE;
}

function formatCurrency(item) {
	return item?.currency_symbol || "";
}

function formatDesc(item) {
	return item?.description || item?.sub_title || item?.subtitle || DEFAULT_DESC;
}

function getItemTitle(item) {
	return item?.title || item?.name || "";
}

function getItemUrl(item) {
	return item?.url || item?.jump_url || "";
}

function toGoLink(url, schannel) {
	if (schannel === "calc-emotion-m") {
		logEvent("home_Emotional_click");
	}

	goLink(url, schannel);
}
</script>

<style lang="scss" scoped>
.m-paid-test {
	margin-top: 48px;
	width: 686px;

	&__title {
		margin: 0 0 16px;
		font-weight: 600;
		font-size: 36px;
		line-height: 56px;
		color: #1f2329;
	}

	&__list {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	&__item {
		display: flex;
		gap: 16px;
		padding: 16px;
		background: #ffffff;
		border: 1px solid #efefef;
		border-radius: 16px;
	}

	&__cover {
		width: 160px;
		height: 160px;
		overflow: hidden;
		border-radius: 8px;
		flex-shrink: 0;
	}

	&__content {
		flex: 1;
		min-width: 0;
	}

	&__name {
		margin: 0;
		font-weight: 600;
		font-size: 30px;
		line-height: 46px;
		color: #2b2f36;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__desc {
		margin: 4px 0 0;
		font-size: 27px;
		line-height: 50px;
		height: 100px;
		color: #4a4a4a;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		line-clamp: 2;
	}

	&__footer {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 12px;
	}

	&__price {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		font-weight: 600;
		font-size: 32px;
		line-height: 56px;
		color: #de2828;

		img {
			width: 32px;
			height: 32px;
			flex-shrink: 0;
		}
	}

	&__button {
		width: 150px;
		height: 56px;
		padding: 0;
		border: none;
		border-radius: 8px;
		background: #333333;
		font-size: 26px;
		line-height: 56px;
		color: #ffffff;
	}
}
</style>
